import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {Subject} from 'rxjs';
import {ModalService} from '../../shared/services/modal.service';
import {AdminService} from '../../shared/services/admin.service';
import {alertMessages, AlertService} from '../../shared/services/alert.service';
import {ModalAdminAreaofinterestComponent} from '../admin-fieldofinterest/modal-admin-areaofinterest/modal-admin-areaofinterest.component';
import {empty} from '../../functions';
import {ModalAdminSchoolComponent} from './modal-admin-school/modal-admin-school.component';
import {catchError} from 'rxjs/operators';

@Component({
    selector: 'app-admin-schools',
    templateUrl: './admin-schools.component.html',
    styleUrls: ['./admin-schools.component.scss'],
    standalone: false
})
export class AdminSchoolsComponent implements OnInit {

  filterOpen = false;

  public view = {
    filters: {
      queryParams: {
        SearchTerm: null,
        SortField: 'name',
        SortType: 'Ascending',
      }
    },
    filterOptions: {
      areaOfInterests: <any>[],
      sites: <any>[],
      status: <any>[],
      educationLevels: <any>[],
    },

  };

  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: 'Image',
        name: 'avatarUri',
        type: 'image',
        class: 'img-64'
      },
      {
        header_name: 'Name',
        name: 'name',
        type: 'text'
      },
      {
        header_name: 'City',
        name: 'address',
        subName: 'city',
        type: 'text'
      },
      {
        header_name: 'Country',
        name: 'address',
        subName: 'country',
        type: 'text'
      }
    ],
    endpoint: 'school',
    data: <any> [],
    buttons: [
      {
        class: 'btn btn-info',
        event: 'classes',
        text: 'Classes'
      },
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject(),
    queryParams: this.view.filters.queryParams
  };

  /**
   * Constructor
   *
   * @param modal
   * @param adminService
   * @param alertService
   */
  constructor(public modal: ModalService, public adminService: AdminService, private alertService: AlertService, private router: Router) { }

  /**
   * Ng on init
   */
  ngOnInit(): void {



  }


  /**
   * Add a single school
   */
  addSchool() {

    const modalOptions = {
      backdrop: 'static',
      size: 'lg'
    };

    const data = {
      entity : {
        id: '',
        name: ''
      }
    }

    this.modal.Modal(ModalAdminSchoolComponent, '', '', data, [], modalOptions).then( (result) => {

      if (result === true) {

        this.alertService.success(alertMessages.successDataSaved);

        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });

  }

  /**
   * Update a single school
   *
   * @param $data
   */
  updateSchool($data:any) {

    const modalOptions = {
      backdrop: 'static',
      size: 'lg'
    };

    const data = {
      entity: $data
    };

    this.modal.Modal(ModalAdminSchoolComponent, '', '', data, [], modalOptions).then( (result) => {

      if (result === true) {

        this.alertService.success(alertMessages.successDataSaved);

        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });

  }

  /**
   * Delete a single school
   *
   * @param id
   */
  deleteSchool(id: string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then( (confirm) => {
      if (confirm === true) {

        this.adminService.apiDeleteSchool(id).pipe(catchError(this.adminService.handleError('apiDeleteSchool', false))).subscribe( (result) => {

          if (result !== false) {

            this.alertService.success(alertMessages.successDataRemoved);

            // Reload data
            this.configTable.reloadListener.next(true);

          }

        });

      }
    }).catch( (error) => {

    });

  }

  /**
   * Handle table button event
   *
   * @param $event
   */
  handleButtonEvent($event:any) {

    if (!empty($event['event'])) {

      switch ($event['event']) {

        case 'classes':
          this.router.navigate(['/admin/schools', $event['data']['id'], 'classes']);
          break;

        case 'edit':
          this.updateSchool($event['data']);
          break;

        case 'delete':
          this.deleteSchool($event['data']['id']);
          break;
      }
    }

  }

  reloadData() {

    this.setQueryParams();

    this.configTable.reloadListener.next(true);
  }

  setQueryParams() {
    this.configTable.queryParams = this.view.filters.queryParams
  }

  resetFilters() {

    this.view.filters = {
      queryParams: {
        SearchTerm: null,
        SortField: 'createdOn',
        SortType: 'Descending',
      }
    }

    this.reloadData();
  }

  applyFilters()
  {
    this.reloadData();
  }

}
